import { fetch_app_data } from '../_partials/_app.js';

const STACK_PAGE_SIZE = 12;

export async function load_stack_page({ api_url, base_body, item, loaded, signal }) {
	if (!item.company_name) {
		return [];
	}

	const limit = base_body.limit || STACK_PAGE_SIZE;
	const loaded_uuids = new Set(loaded.map((job) => job.uuid));
	const last_page = Math.max(1, Math.ceil((item.variant_count || 0) / limit));

	let page = Math.floor(loaded.length / limit) + 1;

	while (page <= last_page) {
		const body = {
			...base_body,
			company: item.company_name,
			limit,
			page,
		};

		delete body.grouped;

		// Pages are walked in order because each page's dedupe depends on the
		// ones already fetched.
		// eslint-disable-next-line no-await-in-loop
		const response = await fetch_app_data(api_url, `/api/listings/search`, {
			method: `POST`,
			body,
			signal,
		});

		const fresh = (response.items || []).filter((job) => !loaded_uuids.has(job.uuid));

		if (fresh.length > 0) {
			return fresh;
		}

		page++;
	}

	return [];
}
